import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, FormGroup, FormControl, Button } from 'react-bootstrap';
import Icon from 'react-fa';
import classNames from 'classnames';
import JobTaskFeedback from './JobTaskFeedback.react';
import JobTypeInput from './JobTypeInput.react';
import JobTaskSpec from '../../stores/specs/JobTaskSpec';

const configValidationState = (task, readOnly) => {
  if (!readOnly) {
    return task.valid ? 'success' : 'error';
  }
  return null;
};

const placeholderContent = '{"key": "value", ...}';

const JobTaskConfigEditor = ({ task, taskIndex, updateTask, removeTask, readOnly }) => (
  <div className='config'>
    <FormGroup validationState={configValidationState(task, readOnly)}>
      <Row>
        { /* Commenting this out until a task name is saveable
          <Col md={6}>
            <FormControl
              type='text'
              value={task.name}
              placeholder='Enter task name'
              onChange={e => updateTask(e, taskIndex, 'name')}
              disabled={readOnly}
            />
          </Col>
        */ }

        <Col md={12}>
          <JobTypeInput
            task={task}
            readOnly={readOnly}
            updateTask={updateTask}
            taskIndex={taskIndex}
          />
        </Col>
      </Row>

      <br />

      <FormControl
        componentClass='textarea'
        className={classNames('saved-job-config', { 'saved-job-form-readonly': readOnly })}
        value={task.displayConfig}
        rows={12}
        onChange={e => updateTask(e, taskIndex, 'config')}
        placeholder={placeholderContent}
      />
    </FormGroup>

    { !readOnly &&
      <div className='task-editor-feedback'>
        <JobTaskFeedback valid={task.valid} />

        <Button
          bsStyle='danger'
          style={{ marginTop: '10px' }}
          onClick={removeTask}
        >
          <Icon name='trash' /> Remove this task
        </Button>
      </div>
    }
  </div>
);

export default JobTaskConfigEditor;

JobTaskConfigEditor.propTypes = {
  task: PropTypes.instanceOf(JobTaskSpec),
  taskIndex: PropTypes.number,
  updateTask: PropTypes.func,
  removeTask: PropTypes.func,
  readOnly: PropTypes.bool,
};
